import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12a4 4 0 1 1 8 0a4 4 0 0 1 -8 0z","key":"svg-0"}],["path",{"d":"M12 12h8","key":"svg-1"}],["path",{"d":"M17 15l3 -3l-3 -3","key":"svg-2"}]]

const IconSwipeRight = createReactComponent('outline', 'swipe-right', 'SwipeRight', __iconNode);

export default IconSwipeRight;